module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1117.5bf20626.png";